
var Model = require("./types/Model.js");
var global = require("global");
// eslint-disable-next-line node/no-missing-require
var ReactNative = require("react-native");
var Linking = ReactNative.Linking;
var Platform = ReactNative.Platform;

module.exports = Model({
	name: "linkopener",
	triggers: triggers
});

function triggers() {
	return {
		open: open
	};
}

function open(data) {
	var uri = (typeof data === "string") ? data : data.uri;

	if(global.cordova){
		// open_link_cordova(uri); Do nothing if on atouchaway launcher
	} else if(Platform.OS === "web" && global.require) {
		open_link_web(uri);
	} else {
		open_link_rn(uri);
	}

	this.emit("usermetrics:trigger:track", "open external web link");
}

/**
 * Opens a URL inside the OSs default browser if inside web
 * @param  {String} uri The URL to open in the browser
 */
function open_link_web(uri){
	try{
		global.require("electron").shell.openExternal(uri);
	} catch(error){
		global.require("nw.gui").Shell.openExternal(uri);
	}
}

function open_link_rn(uri) {
	var logError = console.error.bind(console, "Error opening link:", uri);
	Linking
		.openURL(uri)
		.catch(logError);
}
